var applyZhihuRule = function applyZhihuRule(service) {
  service.addRule('zhizhuImg', {
    filter: 'img',
    replacement: function replacement(_content, node) {
      var formula = node.getAttribute('data-formula'); // Info：这个图片是公式

      if (formula) {
        var isBlockFormula = node.parentElement && node.parentElement.nodeName === 'P' && node.parentElement.innerHTML === node.outerHTML;
        return isBlockFormula ? "$$\n" + formula + "\n$$" : "$" + formula + "$";
      }

      var alt = node.getAttribute('alt') || '';
      var src = node.getAttribute('data-actualsrc') || node.getAttribute('src') || '';
      var title = node.title || '';
      var titlePart = title ? ' "' + title + '"' : '';
      return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
  });
  service.addRule('zhihuNoscript', {
    filter: 'noscript',
    replacement: function replacement() {
      return '';
    }
  });
};

export { applyZhihuRule };